export enum ProjectVisibility {
  Private = 1,
  Shared = 2,
}
